module.exports = __webpack_public_path__ + "img/59.82108129.svg";